/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { PlatformApiResultOfListOfIChingConsultationExportDto } from '../../models/platform-api-result-of-list-of-i-ching-consultation-export-dto';

export interface GetIchingConsultationsMineExport$Params {

/**
 * Optioneel: één raadpleging.
 */
  id?: string | null;
}

export function getIchingConsultationsMineExport(http: HttpClient, rootUrl: string, params?: GetIchingConsultationsMineExport$Params, context?: HttpContext): Observable<StrictHttpResponse<PlatformApiResultOfListOfIChingConsultationExportDto>> {
  const rb = new RequestBuilder(rootUrl, getIchingConsultationsMineExport.PATH, 'get');
  if (params) {
    rb.query('id', params.id, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<PlatformApiResultOfListOfIChingConsultationExportDto>;
    })
  );
}

getIchingConsultationsMineExport.PATH = '/api/iching/consultations/mine/export';
